<style>
  .c-input-signature canvas {
  }

  .c-input-signature {
    display: inline-block;
  }

  .c-input-signature-canvas {
    border:1px solid #dddddd;
  }

  .c-input-signature small {
    padding: 5px;
  }
</style>

<template>
  <div @click="resizeCanvas()" class="c-input-signature">
    <b-form-group
            :description="description"
            :label="label"
            :label-for="id">
      <div class="c-input-signature-canvas">
        <small>{{ Core.Definition.getDefinition('Dessinez dans l\'encadré.') }}</small>
        <VueSignaturePad
                width="100%"
                height="100px"
                ref="signaturePad"/>
      </div>
      <b-button class="btn-sm btn mt-1" @click="clear" variant="danger">{{ Core.Definition.getDefinition('Effacer') }}</b-button>
    </b-form-group>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSignaturePad from 'vue-signature-pad'

  Vue.use(VueSignaturePad);
  export default {
    name: 'InputSignature',
    components: {
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      imgWidth: {type: Number, default: 200}
    },
    watch: {
    },
    mounted () {

      this.$nextTick(() => {
        this.resizeCanvas()
      });
    },
    data () {
      return {
        Core: window.Core,
        dataSignature: {
          modal: {
            show: false
          },
          data: false,
          btnVariant: 'danger'
        }
      }
    },
    methods: {
      resizeCanvas() {
        this.$refs.signaturePad.resizeCanvas()
      },
      clear() {
        this.dataSignature.data = false
        this.$refs.signaturePad.clearSignature()
      },
      save() {
        let signature = this.$refs.signaturePad.saveSignature()
        this.dataSignature.data = signature.data
        this.dataSignature.modal.show = false
        this.dataSignature.btnVariant = 'light'
      },
      getData() {
        return this.dataSignature.data
      }
    }
  }
</script>


